/**
 * The unit type this library serves — the value on the tenant record
 * (accessories integration spec §2.2). The route gate, the API configuration
 * lookup (`verticalApisFor`) and the backend middleware all key on it.
 */
export const ACCESSORIES_UNIT_TYPE = 'accessories';

/**
 * The path segment the application mounts this library at, under the shell:
 * `/home/accessories/...` (spec §2.3). A vertical library is namespaced so one
 * canMatch guards all of it and its segments can never collide with rexine's
 * flat ones.
 */
export const ACCESSORIES_MOUNT = 'accessories';

// No menu groups, menu contributions or route constants yet: there are no screens
// until Phase 3 (spec §2.8). ACCESSORIES_MENU_GROUPS and ACCESSORIES_MENU_CONTRIBUTIONS
// (spec §2.5) arrive with the first screen that needs a leaf.
